export default __webpack_public_path__ + "static/media/Co2EmissionIcon.64601f6e.svg";